export default "__VITE_ASSET__CNyz5yLw__"